import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    marginBottom: 50,
    justifyContent: 'center',
  },
  iconLarge: {
    flex: 0.1,
    alignSelf: 'center',
  },
  upperTextContainerLarge: {
    flexDirection: 'column',
    alignSelf: 'flex-end',
    marginTop: 45,
  },
  textTitleLarge: {
    flex: 0.2,
    color: '#000000',
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'flex-start',
    fontSize: 26,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'left',
  },
  scrollItemsContainer: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  scrollItemsContentContainer: {
    width: '80%',
    marginHorizontal: 'auto',
  },

  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  descriptionContainer: {
    width: '90%',
    margin: 5,
  },
  descriptionText: {
    fontSize: 18,
    paddingLeft: 16,
  },
  textInput: {
    fontSize: 14,
    color: '#3f3a40',
    textAlign: 'left',
    borderColor: '#c9c9c9',
    backgroundColor: 'white',
    borderRadius: 20,
    height: 45,
    width: '100%',
    margin: 5,
    paddingHorizontal: 16,
    borderWidth: 1,
  },
  errorTextContainer: {
    padding: 8,
    borderColor: '#f5c6cb',
    backgroundColor: '#f8d7da',
    borderRadius: 8,
  },
  errorText: {
    color: '#EC1C24',
    fontSize: 16,
  },

  confirmPaymentBtnContainer: {
    margin: 16,
    width: '90%',
    marginTop: 20,
    alignSelf: 'center',
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.34,
    shadowRadius: 6.27,
  },
  confirmPaymentBtn: {
    height: 67,
  },
  confirmPaymentBtnText: {
    fontSize: 18,
  },
  confirmPaymentBtnDisabled: {
    backgroundColor: '#979797',
  },
  itemDetailContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 8,
    paddingTop: 8,
    borderBottomColor: '#e1e0e0',
    borderBottomWidth: 1,
  },
  flex1: {
    flex: 1,
  },
  itemDataContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  fontWeightBold: {
    fontWeight: 'bold',
  },
  topRowOrderItemOnOrdersListLarge: {
    borderWidth: 1,
    borderColor: '#001C47',
    paddingVertical: 10,
    alignSelf: 'center',
    width: '100%',
    borderRadius: 10,
    marginHorizontal: 5,
  },
  disableButton: {
    backgroundColor: '#D9D9D9',
    color: '#6f6f6f',
  },
  mt16: {
    marginTop: 16,
  },
  reasons: {
    color: '#f00',
  },
  topRowText: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 20,
    textAlign: 'center',
    color: '#001C47',
  },
  button: {
    backgroundColor: '#0F6657',
    borderRadius: 4,
    marginTop: 20,
    paddingTop: 12,
    paddingBottom: 12,
  },
  buttonTitle: {
    color: '#FFFFFF',
    fontWeight: '500',
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 0,
    textAlign: 'left',
  },
  buttonContainerLarge: {
    width: '100%',
    paddingRight: 15,
    paddingLeft: 15,
  },
});
